import { defineRouting } from "next-intl/routing";
import { DEFAULT_LOCALE, LOCALES } from "@rmh/defs";

export const routing = defineRouting({
  locales: LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  localePrefix: "as-needed",
  // next-intl defaults NEXT_LOCALE to SameSite=Lax with no Secure. The deployed
  // apps are HTTPS-only, so there is no case where this should travel in
  // cleartext. next-intl cannot set HttpOnly (it is absent from the
  // localeCookie attribute type) and the client-side locale switch writes this
  // cookie via document.cookie, so HttpOnly is deliberately not attempted.
  localeCookie: {
    secure: true,
  },
});
